import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { activeUser } from "../common/redux/actions";
import Avatar from "@mui/material/Avatar";
import Badge from "@mui/material/Badge";
import LogoutIcon from "@mui/icons-material/Logout";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import { Tooltip } from "@mui/material";
import { toast } from "react-toastify";
import VipLogo from "../../images/logo.png";
import { FaSearch } from "react-icons/fa";
import hamburger from "../../images/hamburgerIcon.png";
import apiCall from "../../utils/apiCall";

let mountLimit = 1;

class HeaderNav extends Component {
  state = {
    cartSize: 0,
    tabList: {
      numbers: "VIP Numbers",
      offerzone: "Offer Zone",
      "family-business-pack": "Family Pack",
      orders: "Orders",
      blogs: "Blogs",
    },
  };

  handleLogout() {
    localStorage.clear();
    toast.success("Logout Success");
  }

  async componentDidMount() {
    if (mountLimit == 1) {
      mountLimit++;
      try {
        const { result } = await apiCall(
          "REACT_APP_GET_CART_COUNT",
          "POST",
          {
            limit: this.state.getCartLimit || 20,
            skip: 0,
            getIdFromUserInfo: true,
          },
          false
        );

        if (result && result["success"] && result["totalSize"]) {
          this.setState({ cartSize: result.totalSize });
        } else {
          this.setState({ cartSize: 0 });
        }
      } catch (error) {
        console.log("headerNav componentDidMount Error ::", error);
      }
      setTimeout(() => {
        mountLimit--;
      }, 500);
    }
  }

  render() {
    // console.log('HeaderNav.js::this.state::', this.state);
    // console.log('HeaderNav.js::this.props::', this.props);

    let activeUser = this.props.state.activeUser || {};
    let isGuest = activeUser.currentUser?.isGuest || false;

    return (
      <React.Fragment>
        <nav className="navbar navbar-sticky navbar-expand-lg">
          <div className="container">
            <Link className="navbar-brand" to="/">
              <img src={VipLogo} className="img-fluid" alt="logo" />
            </Link>
            <div className="navCustomContainer">
              <div className="login d-flex">
                <Link
                  style={{ display: isGuest ? "block" : "none" }}
                  to="/Login"
                  className="login-btn-box"
                >
                  <button className="mt-2 btn-login" type="submit">
                    Login
                  </button>
                </Link>
                <Link to={`/cart`}>
                  <Tooltip title={"Cart"} placement={"right"} arrow>
                    <Badge
                      color="warning"
                      overlap="circular"
                      badgeContent={this.props.cartCount || this.state.cartSize}
                      showZero
                    >
                      <Avatar sx={{ m: 1, bgcolor: "#000040" }}>
                        <ShoppingCartIcon />
                      </Avatar>
                    </Badge>
                  </Tooltip>
                </Link>
                <a
                  style={{ display: isGuest ? "none" : "block" }}
                  href={`/`}
                  onClick={this.handleLogout}
                >
                  <Avatar sx={{ m: 1, bgcolor: "#000040" }}>
                    <LogoutIcon />
                  </Avatar>
                </a>
              </div>
              <button
                className="navbar-toggler"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarTogglerDemo01"
                aria-controls="navbarTogglerDemo01"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span>
                  <img src={hamburger} />
                </span>
              </button>
            </div>
            <div className="collapse navbar-collapse" id="navbarTogglerDemo01">
              <div className="search-box">
                <button className="search-bar-btn">
                  <FaSearch />
                </button>
                <label className="search-hero">
                  <input
                    type="text"
                    className="search-bar"
                    placeholder="Searh Number"
                  />
                </label>
              </div>

              <ul className="navbar-nav ms-auto mright">
                {Object.entries(this.state.tabList).map((tab) => (
                  <li key={tab[0]} className="nav-item">
                    <Link
                      className={
                        this.props.activeTabName == tab[0]
                          ? "nav-link active "
                          : "nav-link"
                      }
                      aria-current="page"
                      to={"/" + tab[0]}
                    >
                      {tab[1]}
                    </Link>
                  </li>
                ))}
              </ul>

              <div className="login loginInner">
                <Link to={`/cart`} style={{ marginRight: "10px" }}>
                  <Tooltip title={"Cart"} placement={"left"} arrow>
                    <Badge
                      color="warning"
                      overlap="circular"
                      badgeContent={this.props.cartCount || this.state.cartSize}
                      showZero
                    >
                      <Avatar sx={{ m: 1, bgcolor: "#000040" }}>
                        <ShoppingCartIcon />
                      </Avatar>
                    </Badge>
                  </Tooltip>
                </Link>
                <Link
                  style={{ display: isGuest ? "block" : "none" }}
                  to="/Login"
                  className="login-btn-box"
                >
                  <button className="mt-2 btn-login" type="submit">
                    Login
                  </button>
                </Link>
                <a
                  style={{ display: isGuest ? "none" : "block" }}
                  href={`/`}
                  onClick={this.handleLogout}
                >
                  <Avatar sx={{ m: 1, bgcolor: "#000040" }}>
                    <LogoutIcon />
                  </Avatar>
                </a>
              </div>
            </div>
          </div>
        </nav>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return { state };
};

export default connect(mapStateToProps, { activeUser })(HeaderNav);
